import React from 'react';
import { connect } from 'react-redux';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import axios from 'axios';

import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import RichTextEditor from '../RichTextEditor';
import DOMPurify from 'dompurify';

import buscarEmpresaPorId from '../../actions/empresa/buscarEmpresaPorId';
import buscarPlataformas from '../../actions/empresa/buscarPlataformas';
import buscarGrupos from '../../actions/empresa/buscarGrupos';
import cadastrarEmpresa from '../../actions/empresa/cadastrarEmpresas';
import alterarEmpresa from '../../actions/empresa/alterarEmpresas';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import buscarConfigGratuidadeTipoPreco from '../../actions/empresa/buscarConfigGratuidadeTipoPreco';
import salvarConfigGratuidadeTipoPreco from '../../actions/empresa/salvarConfigGratuidadeTipoPreco';
import listarFiltrosEmpresas from '../../actions/empresa/listarFiltrosEmpresas';

import {
    renderField,
    renderFieldCnpj,
    renderFieldCep,
    renderFieldEmail,
    renderFieldNotaEmpresa,
    renderFieldNumber,
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    renderFieldTelefone,
    renderFieldDataNascimento,
    required,
    tamanhoNotaEmpresa,
    tamanhoPorcentagem,
    minTamnhoCampo,
    validarIP,
    renderFieldMonetarioLabelEncima,
    maxValueMonetario,
} from '../../util/inputs';
import { tipoIntegracao, tipoConfiguracaoConexaoTrecho } from '../../util/constantsUtil';
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';

const TIPOS_PRECO_OPTIONS = [
    { value: 'EXECUTIVO', label: 'Executivo' },
    { value: 'LEITO', label: 'Leito' },
    { value: 'SEMI_LEITO', label: 'Semi Leito' },
    { value: 'CONVENCIONAL', label: 'Convencional' },
    { value: 'LEITO_ESPECIAL', label: 'Leito Cama' },
    { value: 'SEMI_LEITO_ESPECIAL', label: 'Semi Leito Especial' },
    { value: 'EXECUTIVO_ESPECIAL', label: 'Executivo Especial' },
    { value: 'EXECUTIVO_ESPECIAL_1', label: 'Executivo Especial 1' },
    { value: 'EXECUTIVO_ESPECIAL_2', label: 'Executivo Especial 2' },
    { value: 'EXECUTIVO_ESPECIAL_3', label: 'Executivo Especial 3' },
    { value: 'EXECUTIVO_ESPECIAL_4', label: 'Executivo Especial 4' },
    { value: 'EXECUTIVO_ESPECIAL_5', label: 'Executivo Especial 5' },
    { value: 'EXECUTIVO_ESPECIAL_6', label: 'Executivo Especial 6' },
    { value: 'EXECUTIVO_ESPECIAL_7', label: 'Executivo Especial 7' },
    { value: 'EXECUTIVO_ESPECIAL_8', label: 'Executivo Especial 8' },
    { value: 'EXECUTIVO_ESPECIAL_9', label: 'Executivo Especial 9' },
    { value: 'EXECUTIVO_ESPECIAL_10', label: 'Executivo Especial 10' },
    { value: 'CONVENCIONAL_ESPECIAL', label: 'Convencional Especial' },
    { value: 'CONVENCIONAL_ESPECIAL_1', label: 'Convencional Especial 1' },
    { value: 'CONVENCIONAL_ESPECIAL_2', label: 'Convencional Especial 2' },
    { value: 'CONVENCIONAL_ESPECIAL_3', label: 'Convencional Especial 3' },
    { value: 'CONVENCIONAL_ESPECIAL_4', label: 'Convencional Especial 4' },
    { value: 'CONVENCIONAL_ESPECIAL_5', label: 'Convencional Especial 5' },
    { value: 'CONVENCIONAL_ESPECIAL_6', label: 'Convencional Especial 6' },
    { value: 'CONVENCIONAL_ESPECIAL_7', label: 'Convencional Especial 7' },
    { value: 'CONVENCIONAL_ESPECIAL_8', label: 'Convencional Especial 8' },
    { value: 'CONVENCIONAL_ESPECIAL_9', label: 'Convencional Especial 9' },
    { value: 'CONVENCIONAL_ESPECIAL_10', label: 'Convencional Especial 10' },
    { value: 'LEITO_INDIVIDUAL', label: 'Leito Individual' },
    { value: 'LEITO_CAMA_INDIVIDUAL', label: 'Leito-Cama Individual' },
    { value: 'LEITO_CAMA_ESPECIAL_1', label: 'Leito Cama Especial 1' },
    { value: 'LEITO_CAMA_ESPECIAL_2', label: 'Leito Cama Especial 2' },
    { value: 'LEITO_ESPECIAL_1', label: 'Leito Especial 1' },
    { value: 'LEITO_ESPECIAL_2', label: 'Leito Especial 2' },
    { value: 'SEMI_LEITO_ESPECIAL_1', label: 'Semi Leito Especial 1' },
    { value: 'SEMI_LEITO_ESPECIAL_2', label: 'Semi Leito Especial 2' },
    { value: 'LEITO_INDIVIDUAL_ESPECIAL_1', label: 'Leito Individual Especial 1' },
    { value: 'LEITO_INDIVIDUAL_ESPECIAL_2', label: 'Leito Individual Especial 2' },
];

const TODOS_OPTION = { value: '__TODOS__', label: 'TODOS' };

const TIPOS_GRATUIDADE_CONFIG = [
    { tipoEmissao: 'IDOSO_100', label: 'ID Idoso 100%' },
    { tipoEmissao: 'ID_JOVEM_100', label: 'ID Jovem 100%' },
    { tipoEmissao: 'ID_JOVEM_50', label: 'ID Jovem 50%' },
    { tipoEmissao: 'IDOSO_50', label: 'ID Idoso 50%' },
    { tipoEmissao: 'DEFICIENTE', label: 'Deficiente' },
    { tipoEmissao: 'ACOMPANHANTE', label: 'Acompanhante' },
    { tipoEmissao: 'P_LIVRE_POLICIAL_AUDITOR', label: 'P. Livre Policial/Auditor' },
    { tipoEmissao: 'CORTESIA', label: 'Cortesia' },
];

const validate = (values) => {
    const erros = {};
    if (!values.email) erros.email = 'Campo obrigatório';
    if (!values.cep) erros.cep = 'Campo obrigatório';
    if (!values.logradouro) erros.logradouro = 'Campo obrigatório';
    if (!values.bairro) erros.bairro = 'Campo obrigatório';
    return erros;
};

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

export class PainelFormEmpresa extends React.Component {
    constructor(props) {
        super(props);
        this._mounted = false;
        this.submit = this.submit.bind(this);
        this.handleChangeArquivo = this.handleChangeArquivo.bind(this);
        this.handleSalvarConfigGratuidade = this.handleSalvarConfigGratuidade.bind(this);

        this.state = {
            mensagem: { tipo: '', texto: '' },
            grupos: [],
            sitesSelecionados: [],
            integracaoSelecionada: [],
            integracaoAtual: null,
            pagamentosDesativados: [],
            habilitadoRegraConexaoTrecho: true,
            configGratuidade: {},
            carregando: false,
        };
    }

    componentDidMount() {
        this._mounted = true;
        const id = this.props.match && this.props.match.params && this.props.match.params.id;

        this.props.buscarPlataformas();
        this.props.buscarGrupos().then(resp => {
            if (this._mounted && resp.payload.status === 200) {
                this.setState({ grupos: resp.payload.data });
            }
        });

        if (id) {
            this.setState({ carregando: true });
            this.props.buscarEmpresaPorId(id).then(resp => {
                if (!this._mounted) return;
                if (resp.payload.status === 200) {
                    const empresa = resp.payload.data;
                    this.preencherFormulario(empresa);
                    this.props.listarFiltrosEmpresas(id);
                    this.carregarConfigGratuidade(id);
                }
                this.setState({ carregando: false });
            });
        }
    }

    componentWillUnmount() {
        this._mounted = false;
        this.props.selecionarOrigem(null);
    }

    carregarConfigGratuidade(empresaId) {
        this.props.buscarConfigGratuidadeTipoPreco(empresaId).then(resp => {
            if (!this._mounted) return;
            if (resp && resp.payload && resp.payload.data) {
                const mapa = {};
                resp.payload.data.forEach(item => {
                    mapa[item.tipoEmissao] = item.tiposPrecoPermitidos || [];
                });
                this.setState({ configGratuidade: mapa });
            }
        });
    }

    preencherFormulario(empresa) {
        const set = (field, value) =>
            this.props.changeFieldValue('formularioCadastroEmpresa', field, value);

        set('codigoEmpresa', empresa.id);
        set('cnpj', empresa.cnpj);
        set('razaoSocial', empresa.nome);
        set('nomeFantasia', empresa.nomeFantasia);
        set('email', empresa.email);
        set('urlImagem', empresa.urlImagem);
        set('logomarca', empresa.logomarca);
        set('mensagemAvisoBilhete', empresa.mensagemAvisoBilhete);
        set('tempoVisualizacaoDados', empresa.tempoVisualizacaoDados);
        set('avaliacaoEmpresa', empresa.notaEmpresa != null ? Number(empresa.notaEmpresa).toFixed(1) : '0.0');
        set('rodoviaria', empresa.rodoviaria);
        set('turismo', empresa.turismo);
        set('senhaAntt', empresa.turismo ? '********' : '');
        set('rntrc', empresa.rntrc);
        set('opcoesTrechoAlternativo', empresa.opcoesTrechoAlternativo);
        set('habilitadoEncomenda', empresa.habilitadoEncomenda);
        set('permitirRemarcacaoCancelamentoSite', empresa.permitirRemarcacaoCancelamentoSite);
        set('habilitadoVendeGratuidadeApenasConvencional', empresa.habilitadoVendeGratuidadeApenasConvencional);
        set('habilitadoVenderCpfOpcional', empresa.habilitadoVenderCpfOpcional);
        set('habilitadoExibirApenasTipoDocumentoPassaporte', empresa.habilitadoExibirApenasTipoDocumentoPassaporte);
        set('habilitadoBpe', empresa.habilitadoBpe);
        set('tipoControleEmissaoBpe', empresa.tipoControleEmissaoBPe && empresa.tipoControleEmissaoBPe.valor);
        set('habilitadoBpeSites', empresa.habilitadoBpeSites);
        set('habilitadaVendaSeguro', empresa.habilitadaVendaSeguro);
        set('habilitadoRegraBilhete', empresa.habilitadoRegraBilhete);
        set('habilitadoBuscaPassagemHorario', empresa.habilitadoBuscaPassagemHorario);
        set('habilitadoCpfCnpjTitularCompravante', empresa.habilitadoCpfCnpjTitularCompravante);
        set('habilitadoTEF', empresa.habilitadoTEF);
        set('ipTEF', empresa.habilitadoTEF ? empresa.ipTEF : '');
        set('habilitadoPrecoFixoExcessoBagagem', empresa.habilitadoPrecoFixoExcessoBagagem);
        set('precoFixoExcessoBagagem', empresa.habilitadoPrecoFixoExcessoBagagem ? empresa.precoFixoExcessoBagagem : null);
        set('habilitadoCieloEcommerce', empresa.habilitadoCieloEcommerce);
        set('merchantIdCieloEcommerce', empresa.habilitadoCieloEcommerce ? empresa.merchantIdCieloEcommerce : '');
        set('merchantKeyCieloEcommerce', empresa.habilitadoCieloEcommerce ? empresa.merchantKeyCieloEcommerce : '');
        set('habilitadoVendaOffline', empresa.habilitadoVendaOffline);
        set('habilitadoVendaUrbana', empresa.habilitadoVendaUrbana);
        set('habilitadoEncomendaAvulsa', empresa.habilitadoEncomendaAvulsa);
        set('habilitadoComissaoEntregaEncomenda', empresa.habilitadoComissaoEntregaEncomenda);
        set('habilitadoSite', empresa.habilitadoSite);
        set('habilitadoAntt', empresa.habilitadoValorAntt);
        set('habilitadoAgencia', empresa.habilitadoAgencia);
        set('impostoPraticar', empresa.impostoPraticar || '00.00');
        set('comissaoPraticar', empresa.comissaoPraticar || '00.00');
        set('agenteTipoUm', empresa.agenteTipoUm || '00.00');
        set('agenteTipoDois', empresa.agenteTipoDois || '00.00');
        set('agenteTipoTres', empresa.agenteTipoTres || '00.00');
        set('multaRemarcacaoDentroPrazo', empresa.multaRemarcacaoDentroPrazo);
        set('multaRemarcacaoForaPrazo', empresa.multaRemarcacaoForaPrazo);
        set('multaCancelamentoDentroPrazo', empresa.multaCancelamentoDentroPrazo);
        set('multaCancelamentoForaPrazo', empresa.multaCancelamentoForaPrazo);
        set('numeroNotaCte', empresa.numeroNotaCte);
        set('numeroNotaCteOs', empresa.numeroNotaCteOs);
        set('habilitadoEnvioWpp', empresa.habilitadoEnvioWpp);
        set('habilitadoBuscaReservaComBpe', empresa.habilitadoBuscaReservaComBpe);
        set('dataIniciaoVigenciaBuscaReservaComBpe', empresa.dataIniciaoVigenciaBuscaReservaComBpe);
        set('nomeDono', empresa.nomeDono);
        set('telefoneDono', empresa.telefoneDono);
        set('nomeSocio', empresa.nomeSocio);
        set('telefoneSocio', empresa.telefoneSocio);
        set('nomeGerente', empresa.nomeGerente);
        set('telefoneGerente', empresa.telefoneGerente);
        set('nomeCertificado', empresa.nomeCertificado);

        if (empresa.grupo) {
            set('grupo', { label: empresa.grupo, value: empresa.grupo });
        }

        if (empresa.endereco) {
            set('idEndereco', empresa.endereco.id);
            set('cep', empresa.endereco.cep);
            set('logradouro', empresa.endereco.logradouro);
            set('complemento', empresa.endereco.complemento);
            set('bairro', empresa.endereco.bairro);
            set('numero', empresa.endereco.numero);
            set('uf', empresa.endereco.uf);

            if (empresa.endereco.nomeCidade) {
                this.props.selecionarOrigem({
                    id: empresa.endereco.codigoCidade,
                    nome: empresa.endereco.nomeCidade,
                    uf: empresa.endereco.uf,
                });
            }
        }

        if (empresa.telefones && empresa.telefones.length > 0) {
            set('telefoneEmpresa', empresa.telefones[0]);
        }

        const integracoes = (empresa.integracoes || []).map(it => ({
            id: it.id,
            integracao: tipoIntegracao.find(ti => ti.value === it.tipoIntegracao),
            codigoEmpresa: it.codigoEmpresa,
            integracaoAtiva: it.ativo,
        }));

        const sites = (empresa.sites || []).map(s => ({ label: s, value: s }));

        const pagamentos = (empresa.pagamentosDesativados || []).map(p => ({ label: p, value: p }));

        this.setState({
            integracaoSelecionada: integracoes,
            sitesSelecionados: sites,
            pagamentosDesativados: pagamentos,
            habilitadoRegraConexaoTrecho: empresa.habilitadoRegraConexaoTrecho !== false,
        });
    }

    pesquisarPorCep(cep) {
        const numeros = cep.replace(/\D/g, '');
        if (numeros.length !== 8) return;
        axios.get(`${URL}/cep/public/${numeros}`, SLOW_REQUEST_CONFIG).then(resp => {
            if (resp.status === 200) {
                const set = (f, v) => this.props.changeFieldValue('formularioCadastroEmpresa', f, v);
                set('logradouro', resp.data.logradouro);
                set('complemento', resp.data.complemento);
                set('bairro', resp.data.bairro);
                set('uf', resp.data.uf);
            }
        });
    }

    handleChangeArquivo(event) {
        const file = event.target.files[0];
        if (!file) return;
        if (!/\.(jpe?g|png|webp)$/i.test(file.name)) {
            this.setState({ mensagem: { tipo: 'erro', texto: 'Formato inválido. Use JPEG ou PNG.' } });
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.props.changeFieldValue('formularioCadastroEmpresa', 'logoMarca', reader.result);
            this.props.changeFieldValue('formularioCadastroEmpresa', 'logomarca', file.name);
        };
    }

    removerImagem() {
        this.props.changeFieldValue('formularioCadastroEmpresa', 'logoMarca', null);
        this.props.changeFieldValue('formularioCadastroEmpresa', 'urlImagem', null);
        this.props.changeFieldValue('formularioCadastroEmpresa', 'logomarca', null);
    }

    adicionarIntegracao(e) {
        e.preventDefault();
        const { integracaoAtual } = this.state;
        const codigoEmpresa = this.props.codigoEmpresaIntegracao;
        if (!integracaoAtual || !codigoEmpresa) return;
        if (this.state.integracaoSelecionada.find(it => it.integracao && it.integracao.value === integracaoAtual.value)) return;
        this.setState(prev => ({
            integracaoSelecionada: [...prev.integracaoSelecionada, {
                id: null, integracao: integracaoAtual, codigoEmpresa, integracaoAtiva: false,
            }],
            integracaoAtual: null,
        }));
        this.props.changeFieldValue('formularioCadastroEmpresa', 'codigoEmpresaIntegracao', '');
    }

    removerIntegracao(item) {
        this.setState(prev => ({
            integracaoSelecionada: prev.integracaoSelecionada.filter(
                it => it.integracao.value !== item.integracao.value
            ),
        }));
    }

    handleCheckIntegracaoAtiva(item) {
        this.setState(prev => {
            const lista = prev.integracaoSelecionada.map(it => ({ ...it, integracaoAtiva: false }));
            const found = lista.find(it => it.integracao.value === item.integracao.value);
            if (found) found.integracaoAtiva = !item.integracaoAtiva;
            return { integracaoSelecionada: lista };
        });
    }

    selecionarSite(option) {
        if (!option) return;
        this.setState(prev => {
            if (prev.sitesSelecionados.find(s => s.value === option.value)) return prev;
            return { sitesSelecionados: [...prev.sitesSelecionados, option] };
        });
    }

    removerSite(value) {
        this.setState(prev => ({
            sitesSelecionados: prev.sitesSelecionados.filter(s => s.value !== value),
        }));
    }

    adicionarPagamentoDesativado(option) {
        if (!option) return;
        this.setState(prev => {
            if (prev.pagamentosDesativados.find(p => p.value === option.value)) return prev;
            return { pagamentosDesativados: [...prev.pagamentosDesativados, option] };
        });
    }

    removerPagamentoDesativado(option) {
        this.setState(prev => ({
            pagamentosDesativados: prev.pagamentosDesativados.filter(p => p.value !== option.value),
        }));
    }

    handleSalvarConfigGratuidade(tipoEmissao, selectedOptions) {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return;
        const options = selectedOptions || [];
        const contemTodos = options.some(o => o.value === '__TODOS__');
        const novos = contemTodos ? ['TODAS'] : options.filter(o => o.value !== '__TODOS__').map(o => o.value);
        this.setState(prev => ({
            configGratuidade: { ...prev.configGratuidade, [tipoEmissao]: novos },
        }));
        this.props.salvarConfigGratuidadeTipoPreco(id, tipoEmissao, novos);
    }

    montarParametroEmpresa(values) {
        const origem = this.props.origem || {};
        return {
            id: values.codigoEmpresa,
            cnpj: values.cnpj,
            nome: values.razaoSocial,
            nomeFantasia: values.nomeFantasia,
            telefones: values.telefoneEmpresa ? [values.telefoneEmpresa] : [],
            email: values.email,
            base64Logomarca: values.logoMarca,
            logomarca: values.logomarca,
            urlImagem: values.urlImagem,
            rodoviaria: values.rodoviaria,
            turismo: values.turismo,
            senhaAntt: values.senhaAntt === '********' ? null : values.senhaAntt,
            rntrc: values.rntrc,
            opcoesTrechoAlternativo: values.opcoesTrechoAlternativo,
            habilitadoEncomenda: values.habilitadoEncomenda,
            permitirRemarcacaoCancelamentoSite: values.permitirRemarcacaoCancelamentoSite,
            habilitadoVendeGratuidadeApenasConvencional: values.habilitadoVendeGratuidadeApenasConvencional,
            habilitadoVenderCpfOpcional: values.habilitadoVenderCpfOpcional,
            habilitadoExibirApenasTipoDocumentoPassaporte: values.habilitadoExibirApenasTipoDocumentoPassaporte,
            habilitadoBpe: values.habilitadoBpe,
            habilitadoBpeSites: values.habilitadoBpeSites,
            habilitadaVendaSeguro: values.habilitadaVendaSeguro,
            habilitadoRegraBilhete: values.habilitadoRegraBilhete,
            habilitadoBuscaPassagemHorario: values.habilitadoBuscaPassagemHorario,
            habilitadoCpfCnpjTitularCompravante: values.habilitadoCpfCnpjTitularCompravante,
            habilitadoTEF: values.habilitadoTEF,
            ipTEF: values.ipTEF || '',
            habilitadoPrecoFixoExcessoBagagem: values.habilitadoPrecoFixoExcessoBagagem,
            precoFixoExcessoBagagem: values.precoFixoExcessoBagagem
                ? values.precoFixoExcessoBagagem.toString().replace('R$', '').trim()
                : null,
            habilitadoCieloEcommerce: values.habilitadoCieloEcommerce || false,
            merchantIdCieloEcommerce: values.merchantIdCieloEcommerce,
            merchantKeyCieloEcommerce: values.merchantKeyCieloEcommerce,
            habilitadoVendaOffline: values.habilitadoVendaOffline || false,
            habilitadoVendaUrbana: values.habilitadoVendaUrbana || false,
            habilitadoEncomendaAvulsa: values.habilitadoEncomendaAvulsa || false,
            habilitadoComissaoEntregaEncomenda: values.habilitadoComissaoEntregaEncomenda || false,
            habilitadoSite: values.habilitadoSite,
            habilitadoValorAntt: values.habilitadoAntt,
            habilitadoAgencia: values.habilitadoAgencia,
            impostoPraticar: values.impostoPraticar,
            comissaoPraticar: values.comissaoPraticar,
            agenteTipoUm: values.agenteTipoUm,
            agenteTipoDois: values.agenteTipoDois,
            agenteTipoTres: values.agenteTipoTres,
            multaRemarcacaoDentroPrazo: values.multaRemarcacaoDentroPrazo,
            multaRemarcacaoForaPrazo: values.multaRemarcacaoForaPrazo,
            multaCancelamentoDentroPrazo: values.multaCancelamentoDentroPrazo,
            multaCancelamentoForaPrazo: values.multaCancelamentoForaPrazo,
            numeroNotaCte: values.numeroNotaCte,
            numeroNotaCteOs: values.numeroNotaCteOs,
            habilitadoRegraConexaoTrecho: this.state.habilitadoRegraConexaoTrecho,
            notaEmpresa: values.avaliacaoEmpresa || '0.0',
            grupo: values.grupo ? values.grupo.value : null,
            habilitadoEnvioWpp: values.habilitadoEnvioWpp,
            habilitadoBuscaReservaComBpe: values.habilitadoBuscaReservaComBpe,
            dataIniciaoVigenciaBuscaReservaComBpe: values.dataIniciaoVigenciaBuscaReservaComBpe,
            tempoVisualizacaoDados: values.tempoVisualizacaoDados,
            mensagemAvisoBilhete: values.mensagemAvisoBilhete,
            nomeCertificado: values.nomeCertificado,
            nomeDono: values.nomeDono,
            telefoneDono: values.telefoneDono,
            nomeSocio: values.nomeSocio,
            telefoneSocio: values.telefoneSocio,
            nomeGerente: values.nomeGerente,
            telefoneGerente: values.telefoneGerente,
            sites: this.state.sitesSelecionados.map(s => s.value),
            pagamentosDesativados: this.state.pagamentosDesativados.map(p => p.value),
            integracoes: this.state.integracaoSelecionada.map(it => ({
                id: it.id,
                codigoEmpresa: it.codigoEmpresa,
                tipoIntegracao: it.integracao.value,
                ativo: it.integracaoAtiva,
            })),
            endereco: {
                id: values.idEndereco,
                cep: values.cep,
                logradouro: values.logradouro,
                complemento: values.complemento,
                bairro: values.bairro,
                numero: values.numero,
                codigoCidade: origem.id,
                uf: origem.uf,
            },
        };
    }

    submit(values) {
        const ehEdicao = !!values.codigoEmpresa;
        const cmd = this.montarParametroEmpresa(values);
        const formData = new FormData();
        formData.append('file', new Blob([], { type: 'application/octet-stream' }), 'empty');
        formData.append('empresa', new Blob([JSON.stringify(cmd)], { type: 'application/json' }));
        const action = ehEdicao
            ? this.props.alterarEmpresa(formData)
            : this.props.cadastrarEmpresa(formData);

        action.then(resp => {
            if (resp.payload.status === 200) {
                this.props.history.push('/painel-empresas');
            } else {
                const texto = resp.payload.response && resp.payload.response.data &&
                    resp.payload.response.data.mensagens
                    ? resp.payload.response.data.mensagens[0].mensagem
                    : 'Erro ao salvar empresa';
                this.setState({ mensagem: { tipo: 'erro', texto } });
            }
        }).catch(err => {
            const texto = err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Erro ao salvar empresa';
            this.setState({ mensagem: { tipo: 'erro', texto } });
        });
    }

    recuperaMensagem() {
        const { mensagem } = this.state;
        if (!mensagem || !mensagem.tipo) return null;
        const isSucesso = mensagem.tipo === 'sucesso';
        return (
            <div className={`vx-config-alert vx-config-alert--${mensagem.tipo}`}>
                <i className="material-icons">{isSucesso ? 'check_circle' : 'error_outline'}</i>
                <span>{mensagem.texto}</span>
                <button type="button" onClick={() => this.setState({ mensagem: { tipo: '', texto: '' } })}>
                    <i className="material-icons" style={{ fontSize: 18 }}>close</i>
                </button>
            </div>
        );
    }

    exibirGratuidades() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return (
            <p style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>
                Disponível após a empresa ser cadastrada.
            </p>
        );
        return (
            <div>
                <p className="vx-config-gratuidade-hint">
                    Selecione os tipos de serviço permitidos para cada gratuidade. Selecione <strong>TODOS</strong> para liberar em todas as categorias. Alterações salvas automaticamente.
                </p>
                {TIPOS_GRATUIDADE_CONFIG.map(({ tipoEmissao, label }) => {
                    const tiposPermitidos = this.state.configGratuidade[tipoEmissao] || [];
                    const ativo = tiposPermitidos.length > 0;
                    const selectedOptions = tiposPermitidos.includes('TODAS')
                        ? [TODOS_OPTION]
                        : TIPOS_PRECO_OPTIONS.filter(o => tiposPermitidos.includes(o.value));
                    return (
                        <div key={tipoEmissao} className="vx-gratuidade-row">
                            <span className="vx-gratuidade-badge">
                                <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 4, color: ativo ? '#28a745' : '#bbb' }}>
                                    {ativo ? 'check_circle' : 'block'}
                                </i>
                                {label}
                            </span>
                            <div style={{ flex: 1 }}>
                                <Select isMulti isClearable
                                    placeholder="Bloqueado..."
                                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                                    options={[TODOS_OPTION, ...TIPOS_PRECO_OPTIONS]}
                                    value={selectedOptions}
                                    onChange={sel => this.handleSalvarConfigGratuidade(tipoEmissao, sel)}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: b => ({ ...b, zIndex: 9999 }),
                                        control: b => ({ ...b, fontSize: 12, minHeight: 34 }),
                                        multiValue: b => ({ ...b, background: 'rgba(255,106,0,0.12)', borderRadius: 4 }),
                                        multiValueLabel: b => ({ ...b, color: '#c94400', fontWeight: 600 }),
                                        multiValueRemove: b => ({ ...b, color: '#c94400' }),
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    exibirIntegracoes() {
        const { integracaoSelecionada, integracaoAtual } = this.state;
        const opcoesIntegracao = tipoIntegracao.filter(ti =>
            !integracaoSelecionada.some(it => it.integracao && it.integracao.value === ti.value)
        );
        return (
            <div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <div>
                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Tipo de Integração</label>
                        <Select
                            placeholder="Selecione..."
                            options={opcoesIntegracao}
                            value={integracaoAtual}
                            onChange={v => this.setState({ integracaoAtual: v })}
                            noOptionsMessage={() => 'Nenhuma opção encontrada'}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                control: b => ({ ...b, fontSize: 13 }),
                                menuPortal: b => ({ ...b, zIndex: 9999 }),
                            }}
                        />
                    </div>
                    <div>
                        <Field name="codigoEmpresaIntegracao" type="text"
                            component={renderField}
                            label="Código Empresa"
                            css="form-control"
                        />
                    </div>
                </div>
                <button
                    type="button"
                    disabled={!integracaoAtual || !this.props.codigoEmpresaIntegracao}
                    className="btn btn-sm btn-laranja"
                    style={{ width: '100%', marginBottom: 12 }}
                    onClick={e => this.adicionarIntegracao(e)}
                >
                    <i className="material-icons" style={{ fontSize: 16, verticalAlign: 'middle' }}>add</i> Incluir
                </button>

                {integracaoSelecionada.length > 0 && (
                    <div className="vx-integ-list">
                        {integracaoSelecionada.map((it, idx) => (
                            <div key={`integ_${idx}`} className="vx-integ-item">
                                <div className="vx-integ-item-info">
                                    <span className="vx-integ-tipo">{it.integracao && it.integracao.value}</span>
                                    <span className="vx-integ-codigo">{it.codigoEmpresa}</span>
                                </div>
                                <div className="vx-integ-item-actions">
                                    <label className="vx-integ-ativo">
                                        <input type="checkbox" checked={it.integracaoAtiva}
                                            onChange={() => this.handleCheckIntegracaoAtiva(it)} />
                                        <span style={{ fontSize: 11, marginLeft: 4 }}>Ativa</span>
                                    </label>
                                    <button type="button" className="vx-payment-tag" style={{ cursor: 'pointer' }}
                                        onClick={() => this.removerIntegracao(it)}>
                                        <i className="material-icons" style={{ fontSize: 14 }}>close</i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    render() {
        const {
            handleSubmit, submitting, invalid,
            habilitadoBpe, habilitadoTEF, habilitadoPrecoFixoExcessoBagagem,
            habilitadoSite, habilitadoAgencia, habilitadoBuscaReservaComBpe,
            turismo, grupo, logoMarca, urlImagem, mensagemAvisoBilhete,
            rodoviaria, plataformas, tipoPagamentos, origem,
        } = this.props;

        const { sitesSelecionados, pagamentosDesativados, habilitadoRegraConexaoTrecho, carregando } = this.state;
        const ehEdicao = !!(this.props.match && this.props.match.params && this.props.match.params.id);
        const validarRodovTurismo = rodoviaria || turismo;

        const sitesDisponiveis = (plataformas || [])
            .filter(s => s !== 'Todas' && !sitesSelecionados.find(sel => sel.value === s))
            .map(s => ({ label: s, value: s }));

        const pagamentosDisponiveis = (tipoPagamentos || [])
            .filter(tp => !pagamentosDesativados.find(p => p.value === tp.chave))
            .map(tp => ({ value: tp.chave, label: tp.valor }));

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo
                            texto={ehEdicao ? 'Editar Empresa' : 'Nova Empresa'}
                            urlRetorno="/painel-empresas"
                        />                        
                        <div className="col-12 conteudo-internas conteudo-painel">
                            {this.recuperaMensagem()}

                            {carregando ? (
                                <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>
                                    <i className="material-icons" style={{ fontSize: 40 }}>hourglass_empty</i>
                                    <p>Carregando dados da empresa...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit(this.submit)} className="vx-config-page">

                                    {/* ── Identificação ── */}
                                    <SectionCard icon="badge" title="Identificação" subtitle="Dados de registro da empresa">
                                        <div className="vx-form-id-grid">
                                            <div>
                                                <Field name="cnpj" type="text" validate={[required]}
                                                    component={renderFieldCnpj} label="CNPJ/CPF:" css="form-control" />
                                            </div>
                                            <div>
                                                <Field name="razaoSocial" type="text" component={renderField}
                                                    label="Razão Social:" css="form-control" />
                                            </div>
                                            <div>
                                                <Field name="nomeFantasia" type="text" component={renderField}
                                                    label="Nome Fantasia:" css="form-control" />
                                            </div>
                                            <div>
                                                <Field name="telefoneEmpresa" type="text" component={renderFieldTelefone}
                                                    label="Telefone:" css="form-control" />
                                            </div>
                                            <div>
                                                <Field name="email" type="email" component={renderFieldEmail}
                                                    label="E-mail:" css="form-control" readOnly={ehEdicao} />
                                            </div>
                                            <div>
                                                <Field name="rntrc" type="text" component={renderField}
                                                    label="RNTRC:" css="form-control" />
                                            </div>
                                        </div>
                                    </SectionCard>

                                    {/* ── Tipo de Operação + Endereço ── */}
                                    <div className="vx-config-grid">
                                        <SectionCard icon="directions_bus" title="Tipo de Operação" subtitle="Modalidade de transporte">
                                            <div className="vx-toggle-row">
                                                <div className="vx-toggle-info">
                                                    <div className="vx-toggle-info-title">Rodoviária</div>
                                                    <div className="vx-toggle-info-desc">Transporte rodoviário convencional</div>
                                                </div>
                                                <Field name="rodoviaria" type="checkbox" component={renderToggle} />
                                            </div>
                                            <div className="vx-toggle-row">
                                                <div className="vx-toggle-info">
                                                    <div className="vx-toggle-info-title">Turismo</div>
                                                    <div className="vx-toggle-info-desc">Transporte turístico / fretamento</div>
                                                    {turismo && (
                                                        <div className="vx-toggle-sub">
                                                            <Field name="senhaAntt" type="text" component={renderField}
                                                                label="Senha ANTT:" validate={[required, minTamnhoCampo]}
                                                                css="form-control" />
                                                        </div>
                                                    )}
                                                </div>
                                                <Field name="turismo" type="checkbox" component={renderToggle} />
                                            </div>
                                            {!validarRodovTurismo && (
                                                <p style={{ color: 'red', fontSize: 11, marginTop: 8 }}>
                                                    Selecione pelo menos um tipo de operação.
                                                </p>
                                            )}
                                        </SectionCard>

                                        <SectionCard icon="location_on" title="Endereço" subtitle="Localização da empresa">
                                            <div className="vx-multa-grid">
                                                <div style={{ gridColumn: '1/-1' }}>
                                                    <Field name="cep" type="text" component={renderFieldCep}
                                                        label="CEP:" css="form-control"
                                                        onChange={e => this.pesquisarPorCep(e.target.value)} />
                                                </div>
                                                <div style={{ gridColumn: '1/-1' }}>
                                                    <Field name="logradouro" type="text" component={renderField}
                                                        label="Logradouro:" css="form-control" />
                                                </div>
                                                <div>
                                                    <Field name="complemento" type="text" component={renderField}
                                                        label="Complemento:" css="form-control" />
                                                </div>
                                                <div>
                                                    <Field name="numero" type="text" component={renderField}
                                                        label="Número:" css="form-control" />
                                                </div>
                                                <div style={{ gridColumn: '1/-1' }}>
                                                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4, marginTop: 8 }}>Cidade:</label>
                                                    <SelecaoCidadeAutocomplete
                                                        name="Informe nome da cidade"
                                                        selecionarCidade={this.props.selecionarOrigem}
                                                        value={origem}
                                                    />
                                                </div>
                                                <div style={{ gridColumn: '1/-1' }}>
                                                    <Field name="bairro" type="text" component={renderField}
                                                        label="Bairro:" css="form-control" />
                                                </div>
                                            </div>
                                            <Field name="idEndereco" type="hidden" component={renderField} css="form-control" />
                                        </SectionCard>
                                    </div>

                                    {/* ── Responsáveis ── */}
                                    <SectionCard icon="people" title="Responsáveis" subtitle="Dono, sócio e gerente da empresa">
                                        <div className="vx-form-resp-grid">
                                            {[
                                                { titulo: 'Dono', nome: 'nomeDono', tel: 'telefoneDono' },
                                                { titulo: 'Sócio', nome: 'nomeSocio', tel: 'telefoneSocio' },
                                                { titulo: 'Gerente', nome: 'nomeGerente', tel: 'telefoneGerente' },
                                            ].map(({ titulo, nome, tel }) => (
                                                <div key={titulo} className="vx-form-resp-item">
                                                    <div className="vx-form-resp-titulo">{titulo}</div>
                                                    <Field name={nome} type="text" component={renderField}
                                                        label="Nome completo:" css="form-control" />
                                                    <Field name={tel} type="text" component={renderFieldTelefone}
                                                        label="Telefone:" css="form-control" />
                                                </div>
                                            ))}
                                        </div>
                                    </SectionCard>

                                    {/* ── Multas + Conexão ── */}
                                    <div className="vx-config-grid">
                                        <SectionCard icon="gavel" title="Políticas de Multa" subtitle="Percentuais de remarcação e cancelamento">
                                            <div className="vx-multa-grid">
                                                {[
                                                    { name: 'multaRemarcacaoDentroPrazo', label: 'Remarcação dentro do prazo (%)' },
                                                    { name: 'multaRemarcacaoForaPrazo', label: 'Remarcação fora do prazo (%)' },
                                                    { name: 'multaCancelamentoDentroPrazo', label: 'Cancelamento dentro do prazo (%)' },
                                                    { name: 'multaCancelamentoForaPrazo', label: 'Cancelamento fora do prazo (%)' },
                                                ].map(({ name, label }) => (
                                                    <div key={name} className="vx-multa-item">
                                                        <Field name={name} validate={[required, tamanhoPorcentagem]}
                                                            component={renderFieldNumerosPorcentagem}
                                                            css="form-control" label={label} />
                                                    </div>
                                                ))}
                                            </div>
                                        </SectionCard>

                                        <SectionCard icon="device_hub" title="Conexão de Trecho" subtitle="Regra de vínculo entre trechos">
                                            <div className="vx-radio-cards">
                                                {[
                                                    { val: true, label: tipoConfiguracaoConexaoTrecho.regraAtual.valor, desc: 'Regra atual' },
                                                    { val: false, label: tipoConfiguracaoConexaoTrecho.regraAntiga.valor, desc: 'Regra legada' },
                                                ].map(({ val, label, desc }) => {
                                                    const selected = val === true
                                                        ? habilitadoRegraConexaoTrecho === true
                                                        : habilitadoRegraConexaoTrecho !== true;
                                                    return (
                                                        <div key={String(val)}
                                                            className={`vx-radio-card${selected ? ' vx-radio-card--selected' : ''}`}
                                                            onClick={() => this.setState({ habilitadoRegraConexaoTrecho: val })}>
                                                            <div className="vx-radio-card-title">
                                                                <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle', marginRight: 5, color: selected ? 'var(--vx-primary)' : '#ccc' }}>
                                                                    {selected ? 'radio_button_checked' : 'radio_button_unchecked'}
                                                                </i>
                                                                {label}
                                                            </div>
                                                            <div className="vx-radio-card-desc">{desc}</div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </SectionCard>
                                    </div>

                                    {/* ── Habilitações ── */}
                                    <SectionCard icon="toggle_on" title="Habilitações" subtitle="Funcionalidades ativas para esta empresa">
                                        {[
                                            { name: 'habilitadoEncomenda', title: 'Encomenda', desc: 'Habilita serviço de encomenda' },
                                            { name: 'permitirRemarcacaoCancelamentoSite', title: 'Remarc./Cancelamento no Site', desc: 'Permite remarcação e cancelamento via site' },
                                            { name: 'habilitadoVendeGratuidadeApenasConvencional', title: 'Gratuidade Apenas Convencional', desc: 'Restringe gratuidade ao tipo convencional' },
                                            { name: 'habilitadoVenderCpfOpcional', title: 'CPF Opcional na Venda', desc: 'CPF não obrigatório na venda' },
                                            { name: 'habilitadoExibirApenasTipoDocumentoPassaporte', title: 'Exibir Apenas Passaporte', desc: 'Exibe somente documento Passaporte' },
                                            { name: 'habilitadoBpeSites', title: 'BPe nos Sites/Agências', desc: 'Emissão de BPe em canais externos' },
                                            { name: 'habilitadaVendaSeguro', title: 'Venda de Seguro', desc: 'Habilita oferta de seguro viagem' },
                                            { name: 'habilitadoRegraBilhete', title: 'Regra Bilhete', desc: 'Aplica regras específicas de bilhete' },
                                            { name: 'habilitadoBuscaPassagemHorario', title: 'Busca por Horário', desc: 'Permite filtrar passagens por horário' },
                                            { name: 'habilitadoCpfCnpjTitularCompravante', title: 'CPF/CNPJ no Comprovante', desc: 'Exige documento do titular no fechamento de caixa' },
                                            { name: 'opcoesTrechoAlternativo', title: 'Trecho Alternativo', desc: 'Exibe opção de trecho alternativo' },
                                            { name: 'habilitadoVendaOffline', title: 'Venda Offline', desc: 'Permite que operadores realizem vendas sem conexão com a internet' },
                                            { name: 'habilitadoVendaUrbana', title: 'Vendas Urbanas', desc: 'Permite a venda avulsa dentro da cidade, vinculada a um itinerário aberto, sem seleção de poltrona' },
                                            { name: 'habilitadoEncomendaAvulsa', title: 'Encomenda Avulsa', desc: 'Permite a venda de encomendas avulsas vinculadas a um itinerário aberto, com impressão de vias e etiquetas por volume' },
                                            { name: 'habilitadoComissaoEntregaEncomenda', title: 'Comissão de Entrega de Encomenda', desc: 'Permite comissionar o usuário responsável por finalizar a entrega de uma encomenda' },
                                        ].map(({ name, title, desc }) => (
                                            <div key={name} className="vx-toggle-row">
                                                <div className="vx-toggle-info">
                                                    <div className="vx-toggle-info-title">{title}</div>
                                                    <div className="vx-toggle-info-desc">{desc}</div>
                                                </div>
                                                <Field name={name} type="checkbox" component={renderToggle} />
                                            </div>
                                        ))}

                                        <div className="vx-toggle-row">
                                            <div className="vx-toggle-info">
                                                <div className="vx-toggle-info-title">Emissão de BPe</div>
                                                <div className="vx-toggle-info-desc">Habilita emissão de Bilhete de Passagem Eletrônico</div>
                                                {habilitadoBpe && (
                                                    <div className="vx-toggle-sub">
                                                        <Field name="tipoControleEmissaoBpe" type="text"
                                                            component={renderField} label="Controle Emissão BPe:"
                                                            css="form-control" readOnly={true} />
                                                    </div>
                                                )}
                                            </div>
                                            <Field name="habilitadoBpe" type="checkbox" component={renderToggle} />
                                        </div>

                                        <div className="vx-toggle-row">
                                            <div className="vx-toggle-info">
                                                <div className="vx-toggle-info-title">Venda via TEF</div>
                                                <div className="vx-toggle-info-desc">Terminal de pagamento eletrônico</div>
                                                {habilitadoTEF && (
                                                    <div className="vx-toggle-sub">
                                                        <Field name="ipTEF" type="text" component={renderField}
                                                            label="IP do Servidor TEF" validate={[required, validarIP]}
                                                            css="form-control" />
                                                    </div>
                                                )}
                                            </div>
                                            <Field name="habilitadoTEF" type="checkbox" component={renderToggle} />
                                        </div>

                                        <div className="vx-toggle-row">
                                            <div className="vx-toggle-info">
                                                <div className="vx-toggle-info-title">Preço Fixo – Excesso de Bagagem</div>
                                                <div className="vx-toggle-info-desc">Valor fixo para cobrança de excesso</div>
                                                {habilitadoPrecoFixoExcessoBagagem && (
                                                    <div className="vx-toggle-sub">
                                                        <Field name="precoFixoExcessoBagagem"
                                                            validate={[maxValueMonetario, required]}
                                                            component={renderFieldMonetarioLabelEncima}
                                                            label="Preço fixo Excesso Bagagem:" css="form-control" />
                                                    </div>
                                                )}
                                            </div>
                                            <Field name="habilitadoPrecoFixoExcessoBagagem" type="checkbox" component={renderToggle} />
                                        </div>
                                    </SectionCard>

                                    {/* ── Canais de Venda ── */}
                                    <SectionCard icon="store" title="Canais de Venda" subtitle="Site, agências e comissões">
                                        <div className="vx-toggle-row">
                                            <div className="vx-toggle-info">
                                                <div className="vx-toggle-info-title">Venda no Site</div>
                                                <div className="vx-toggle-info-desc">Habilita a empresa para vendas via site</div>
                                            </div>
                                            <Field name="habilitadoSite" type="checkbox" component={renderToggle} />
                                        </div>

                                        {habilitadoSite && (
                                            <div className="vx-toggle-sub" style={{ marginTop: 12 }}>
                                                <div className="vx-toggle-row" style={{ padding: '8px 0' }}>
                                                    <div className="vx-toggle-info">
                                                        <div className="vx-toggle-info-title">Vender com valor ANTT</div>
                                                    </div>
                                                    <Field name="habilitadoAntt" type="checkbox" component={renderToggle} />
                                                </div>
                                                <div className="vx-toggle-row" style={{ padding: '8px 0' }}>
                                                    <div className="vx-toggle-info">
                                                        <div className="vx-toggle-info-title">Habilitar para Agências</div>
                                                        <div className="vx-toggle-info-desc">Permite vendas via agências parceiras</div>
                                                    </div>
                                                    <Field name="habilitadoAgencia" type="checkbox" component={renderToggle} />
                                                </div>

                                                {habilitadoAgencia && (
                                                    <div style={{ marginTop: 12 }}>
                                                        <div className="vx-multa-grid">
                                                            <div className="vx-multa-item">
                                                                <Field name="impostoPraticar" validate={[required, tamanhoPorcentagem]}
                                                                    component={renderFieldNumerosPorcentagem}
                                                                    css="form-control" label="Imposto a Praticar (%)" />
                                                            </div>
                                                            <div className="vx-multa-item">
                                                                <Field name="comissaoPraticar" validate={[required, tamanhoPorcentagem]}
                                                                    component={renderFieldNumerosPorcentagem}
                                                                    css="form-control" label="Comissão a Praticar (%)" />
                                                            </div>
                                                        </div>
                                                        <p style={{ fontSize: 11, fontWeight: 700, color: '#555', margin: '12px 0 6px', textTransform: 'uppercase', letterSpacing: 0.5 }}>Comissões das Agências</p>
                                                        <div className="vx-multa-grid">
                                                            {[
                                                                { name: 'agenteTipoUm', label: 'Agente Tipo 1 (%)' },
                                                                { name: 'agenteTipoDois', label: 'Agente Tipo 2 (%)' },
                                                                { name: 'agenteTipoTres', label: 'Agente Tipo 3 (%)' },
                                                            ].map(({ name, label }) => (
                                                                <div key={name} className="vx-multa-item">
                                                                    <Field name={name} validate={[required, tamanhoPorcentagem]}
                                                                        component={renderFieldNumerosPorcentagem}
                                                                        css="form-control" label={label} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                <div style={{ marginTop: 12 }}>
                                                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Sites Habilitados</label>
                                                    <Select
                                                        placeholder="Selecione o site para adicionar..."
                                                        options={sitesDisponiveis}
                                                        value={null}
                                                        onChange={e => this.selecionarSite(e)}
                                                        noOptionsMessage={() => 'Nenhuma opção encontrada'}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        styles={{
                                                            control: b => ({ ...b, fontSize: 13 }),
                                                            menuPortal: b => ({ ...b, zIndex: 9999 }),
                                                        }}
                                                    />
                                                    <div className="vx-payment-tags" style={{ marginTop: 8 }}>
                                                        {sitesSelecionados.length === 0
                                                            ? <span className="vx-payment-empty">Nenhum site selecionado</span>
                                                            : sitesSelecionados.map(s => (
                                                                <span key={s.value} className="vx-payment-tag">
                                                                    {s.label}
                                                                    <button type="button" onClick={() => this.removerSite(s.value)}>
                                                                        <i className="material-icons" style={{ fontSize: 14 }}>close</i>
                                                                    </button>
                                                                </span>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </SectionCard>

                                    {/* ── Gratuidades ── */}
                                    <SectionCard icon="card_giftcard" title="Gratuidades por Tipo de Serviço" subtitle="Categorias de passagem habilitadas para cada benefício">
                                        {this.exibirGratuidades()}
                                    </SectionCard>

                                    {/* ── Integrações + Extras ── */}
                                    <div className="vx-config-grid">
                                        <SectionCard icon="sync_alt" title="Integrações" subtitle="Conexões com sistemas externos">
                                            {this.exibirIntegracoes()}
                                            <div style={{ marginTop: 12 }}>
                                                <div className="vx-toggle-row">
                                                    <div className="vx-toggle-info">
                                                        <div className="vx-toggle-info-title">Reservas com BPe</div>
                                                    </div>
                                                    <Field name="habilitadoBuscaReservaComBpe" type="checkbox" component={renderToggle} />
                                                </div>
                                                {habilitadoBuscaReservaComBpe && (
                                                    <div className="vx-toggle-sub">
                                                        <Field name="dataIniciaoVigenciaBuscaReservaComBpe" type="text"
                                                            component={renderFieldDataNascimento}
                                                            validate={[required]}
                                                            css="form-control" label="Data de início vigência BPe" />
                                                    </div>
                                                )}
                                                {(grupo === undefined || grupo === null || (grupo.value !== 'BUSER')) && (
                                                    <div className="vx-toggle-row">
                                                        <div className="vx-toggle-info">
                                                            <div className="vx-toggle-info-title">Envio via WhatsApp</div>
                                                        </div>
                                                        <Field name="habilitadoEnvioWpp" type="checkbox" component={renderToggle} />
                                                    </div>
                                                )}
                                            </div>
                                        </SectionCard>

                                        <SectionCard icon="tune" title="Configurações Adicionais" subtitle="Dados numéricos e classificação">
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                <Field name="tempoVisualizacaoDados" type="text"
                                                    component={renderFieldNumber} formatacao="##"
                                                    label="Tempo de visualização de dados (em Dias):"
                                                    css="form-control" readOnly={false} />
                                                <Field name="numeroNotaCte" type="text"
                                                    component={renderFieldNumber} formatacao="#########"
                                                    label="Número Nota Cte:" css="form-control" readOnly={false} />
                                                <Field name="numeroNotaCteOs" type="text"
                                                    component={renderFieldNumber} formatacao="#########"
                                                    label="Número Nota Cte Os:" css="form-control" readOnly={false} />
                                                <Field name="avaliacaoEmpresa"
                                                    validate={[tamanhoNotaEmpresa]}
                                                    component={renderFieldNotaEmpresa}
                                                    css="form-control" label="Avaliação nota empresa" placeholder="Avalie" />
                                                <Field name="grupo"
                                                    options={(this.state.grupos || []).map(g => ({ descricao: g, nome: g }))}
                                                    component={renderFieldSelect}
                                                    label="Grupo" placeholder="Selecione..." isClearable={true}
                                                    menuPortalTarget={document.body} />
                                            </div>
                                        </SectionCard>
                                    </div>

                                    {/* ── Pagamentos Desativados ── */}
                                    <SectionCard icon="money_off" title="Pagamentos Desativados" subtitle="Formas de pagamento bloqueadas nesta empresa">
                                        <Select
                                            placeholder="Adicionar pagamento para desativar..."
                                            options={pagamentosDisponiveis}
                                            value={null}
                                            onChange={e => this.adicionarPagamentoDesativado(e)}
                                            noOptionsMessage={() => 'Nenhuma opção disponível'}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                control: b => ({ ...b, fontSize: 13 }),
                                                menuPortal: b => ({ ...b, zIndex: 9999 }),
                                            }}
                                        />
                                        <div className="vx-payment-tags">
                                            {pagamentosDesativados.length === 0
                                                ? <span className="vx-payment-empty">Todos os meios de pagamento ativos</span>
                                                : pagamentosDesativados.map(p => (
                                                    <span key={`pd_${p.value}`} className="vx-payment-tag">
                                                        {p.label}
                                                        <button type="button" onClick={() => this.removerPagamentoDesativado(p)}>
                                                            <i className="material-icons" style={{ fontSize: 14 }}>close</i>
                                                        </button>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </SectionCard>

                                    {/* ── Conteúdo e Identidade ── */}
                                    <SectionCard icon="palette" title="Conteúdo e Identidade" subtitle="Mensagem no bilhete e logomarca">
                                        <div className="form-group">
                                            <Field name="mensagemAvisoBilhete"
                                                component={RichTextEditor}
                                                label="Mensagem em bilhete:" />
                                            {mensagemAvisoBilhete && (
                                                <div className="form-group mt-2">
                                                    <label style={{ fontSize: 12, fontWeight: 600 }}>Pré-visualização:</label>
                                                    <div style={{ border: '1px solid #eee', borderRadius: 6, padding: 10, marginTop: 4 }}
                                                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mensagemAvisoBilhete) }} />
                                                </div>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>Logomarca:</label>
                                            <div className="input-wrapper">
                                                <label htmlFor="input-file-logo">
                                                    {(logoMarca || urlImagem) ? 'Alterar Logomarca' : 'Selecionar Logomarca'}
                                                </label>
                                                <input id="input-file-logo" type="file" value="" accept="image/*"
                                                    onChange={this.handleChangeArquivo} />
                                            </div>
                                            {(logoMarca || urlImagem) && (
                                                <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 10 }}>
                                                    <img alt="Logomarca" style={{ maxWidth: 160, borderRadius: 8, border: '1px solid #eee' }}
                                                        src={logoMarca || urlImagem} />
                                                    <button type="button" className="btn btn-sm btn-outline-secondary"
                                                        onClick={() => this.removerImagem()}>
                                                        <i className="material-icons" style={{ fontSize: 14, color: 'red', verticalAlign: 'middle' }}>close</i> Remover
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </SectionCard>

                                    {/* hidden fields */}
                                    <div className="area-codigo" style={{ display: 'none' }}>
                                        <Field name="codigoEmpresa" type="hidden" component={renderField} css="form-control" />
                                        <Field name="nomeCertificado" type="hidden" component={renderField} css="form-control" />
                                        <Field name="codigoUsuario" type="hidden" component={renderField} css="form-control" />
                                    </div>

                                    {/* ── Save bar ── */}
                                    <div className="vx-config-save-bar">
                                        <span className="vx-config-save-hint">
                                            <i className="material-icons">info_outline</i>
                                            Gratuidades salvas automaticamente · Campos com * são obrigatórios
                                        </span>
                                        <button
                                            type="submit"
                                            disabled={invalid || submitting || !validarRodovTurismo || !origem}
                                            className="btn btn-laranja vx-config-save-btn"
                                        >
                                            <i className="material-icons">save</i>
                                            {ehEdicao ? 'Salvar Alterações' : 'Cadastrar Empresa'}
                                        </button>
                                    </div>

                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </Autorizacao>
        );
    }
}

const selector = formValueSelector('formularioCadastroEmpresa');

function mapStateToProps(state) {
    return {
        origem: state.origem,
        plataformas: state.plataformas || [],
        tipoPagamentos: (state.filtrosEmpresas && state.filtrosEmpresas.tipoPagamentos) || [],
        habilitadoBpe: selector(state, 'habilitadoBpe'),
        habilitadoTEF: selector(state, 'habilitadoTEF'),
        habilitadoPrecoFixoExcessoBagagem: selector(state, 'habilitadoPrecoFixoExcessoBagagem'),
        habilitadoSite: selector(state, 'habilitadoSite'),
        habilitadoAgencia: selector(state, 'habilitadoAgencia'),
        habilitadoBuscaReservaComBpe: selector(state, 'habilitadoBuscaReservaComBpe'),
        turismo: selector(state, 'turismo'),
        rodoviaria: selector(state, 'rodoviaria'),
        grupo: selector(state, 'grupo'),
        logoMarca: selector(state, 'logoMarca'),
        urlImagem: selector(state, 'urlImagem'),
        mensagemAvisoBilhete: selector(state, 'mensagemAvisoBilhete'),
        codigoEmpresaIntegracao: selector(state, 'codigoEmpresaIntegracao'),
    };
}

const mapDispatchToProps = dispatch => bindActionCreators({
    changeFieldValue,
    buscarEmpresaPorId,
    buscarPlataformas,
    buscarGrupos,
    cadastrarEmpresa,
    alterarEmpresa,
    selecionarOrigem,
    buscarConfigGratuidadeTipoPreco,
    salvarConfigGratuidadeTipoPreco,
    listarFiltrosEmpresas,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroEmpresa',
    validate,
    enableReinitialize: false,
})(PainelFormEmpresa));
